import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfirm } from '../layout/ConfirmProvider';
import { useToast } from '../layout/ToastProvider';
import { translateRiskProbability, translateRiskImpact, sortProbabilityScales } from './riskI18nUtils';

import CloseIcon from "../../assets/images/close.png";
import { useDrop } from 'react-dnd';
import DraggableControlCard from './DraggableControlCard';
/*
import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownRed from "../../assets/images/arrow_down_red.png";
import ArrowUpGreen from "../../assets/images/arrow_up_green.png";

import LOADER from "../../assets/images/loader.svg";
import LOADER_BLUE from "../../assets/images/loader_blue.svg";


import PREVENTIVE from "../../assets/images/preventive.svg";
*/

import ArrowUpRed from "../../assets/images/arrow_up_red.png";
import ArrowDownGreen from "../../assets/images/arrow_down_green.png";
import Nill from "../../assets/images/nill.png";

import { Disable } from 'react-disable';
import { TfiTrash } from "react-icons/tfi";


import { connect } from "react-redux";
import { compose } from "redux";


import { editRiskSave, getRisk, getLevels, addComment, addControl, addAction, addAttachment, editRisk, editControl, editAction, deleteControl, deleteAction, aiControlDrop } from "../../store/actions/riskActions";

import Select from 'react-select'

import moment from 'moment';
import debounce from "lodash/debounce";
import { CommentsSection } from "../Comments";
import { Modal, ModalHeader, ModalBody } from "../ui";
import { set } from 'lodash';
import { fromArray } from '@amcharts/amcharts4/.internal/core/utils/Iterator';


const customStyles = {
    control: (provided, state) => ({
        ...provided,
        border: 'none', // Remove the border
        boxShadow: state.isFocused
            ? 'inset 0 -2px 0 0 #3b3b3b' // Add a focused bottom border effect using boxShadow
            : 'none', // Default to light gray bottom shadow
        backgroundColor: '#EEF0ED',
        padding: 1,
        transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
        '&:hover': {
            boxShadow: state.isFocused
                ? 'inset 0 -2px 0 0 #3b3b3b' // Keep dark blue on hover if focused
                : 'inset 0 -2px 0 0 #ccc', // Otherwise, show light gray on hover
        },
    }),

    menu: (provided) => ({
        ...provided,
        border: 'none', // Remove the border around the menu
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#3b3b3b'
            : state.isFocused
            ? '#EEF0ED'
            : 'white', // Different background colors for selected, focused, and default
        color: state.isSelected ? 'white' : '#000',
        '&:hover': {
            backgroundColor: '#EEF0ED', // Light background on hover
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#000',
    }),
};

const formatCurrency = (value) => {
    if (value >= 1_000_000) {
        return `${(value / 1_000_000).toFixed(1)}M`; // Convert to millions with one decimal
    } else if (value >= 1_000) {
        return `${(value / 1_000).toFixed(1)}K`; // Convert to thousands with one decimal
    }
    return value; // For values less than 1K, display the raw number
};

const probabilityOption = (props) => {
    const { innerRef, innerProps, data, isFocused, selectProps } = props;
    const { context, setHoveredData } = selectProps;
    ////////console.log("data: ", data);

    let displayValue;
    if (context === "probability") {
        displayValue = data.frequency;
    } else if (context === "operational") {
        displayValue = data.impact.operational;
    } else if (context === "financial") {
        const v = data.value;
        if (v === 'Catastrophe') {
            displayValue = `> $${formatCurrency(data.impact.financial_low || 0)}`;
        } else if (v === 'Insignificant') {
            displayValue = `< $${formatCurrency(data.impact.financial_high || 0)}`;
        } else {
            displayValue = `$${formatCurrency(data.impact.financial_low || 0)} - $${formatCurrency(data.impact.financial_high || 0)}`;
        }
    } else if (context === "reputational") {
        displayValue = data.impact.reputational;
    } else if (context === "strategic") {
        displayValue = data.impact.strategic;
    }
    else{
        setHoveredData(null);
    }

    ////////console.log("displayValue:",displayValue);

    const handleMouseEnter = (event) => {
        const rect = event.target.getBoundingClientRect(); // Get the dropdown item's position
        const container = document.querySelector('.p-8'); // Reference the scrollable form
        ////////console.log("handle mouse enter!!!");
    
        if (!container) {
            console.error("Scrollable container not found!");
            return;
        }
    
        const containerRect = container.getBoundingClientRect(); // Position of the container relative to the viewport
        const scrollOffset = container.scrollTop; // Scroll offset within the container
    
        const isRightmost = rect.right > containerRect.left + containerRect.width - 450;// Check if dropdown is near the right edge
    
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.style.whiteSpace = "nowrap"; // Prevent wrappinghow
        tempDiv.style.font = "inherit"; // Match font styles
        tempDiv.textContent = displayValue;
    
        document.body.appendChild(tempDiv);
        const hoverWidth = tempDiv.offsetWidth; // Measure the width
        const hoverHeight = tempDiv.offsetHeight;
        document.body.removeChild(tempDiv); 

        const adjustmentFactor = hoverWidth * 0.1; // Adjust by 10% of the hover width

        const hoverPosition = isRightmost
            ? { // Position on the left for rightmost dropdown
                top: rect.top - containerRect.top + scrollOffset + rect.height / 2 - hoverHeight / 2,
                left: rect.left - containerRect.left - hoverWidth - adjustmentFactor,
            }
            : { // Default to position on the right
                top: rect.top - containerRect.top + scrollOffset + rect.height / 2 - hoverHeight / 2,
                left: rect.right - containerRect.left + adjustmentFactor,
            };
    
        ////////console.log("setHiveredData value: ", displayValue);
        setHoveredData({
            value: displayValue,
            position: hoverPosition,
        });
    };

    const handleMouseLeave = () => setHoveredData(null);


    return (
        <div
            ref={innerRef}
            {...innerProps}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: 10,
                backgroundColor: isFocused ? '#e6f7ff' : 'white',
                cursor: 'pointer',
            }}
        >
            {/* Color Indicator */}
            <div
                style={{
                    width: 20,
                    height: 20,
                    marginRight: 10,
                    backgroundColor: data.color,
                    borderRadius: 5,
                }}
            />
            <span>{data.label}</span>
        </div>
    );
};

const probabilitySingleValue = (props) => {
    const { data } = props;
    const v = data.value;
    const short =
        v === "Almost certain" ||
        v === "Almost Certain" ||
        v === "Catastrophe" ||
        v === "Not started"
            ? `${String(data.label).substring(0, 7)}...`
            : data.label;
    return data.label !== "Preventive" && data.label !== "Detective" && data.label !== "Corrective" ? (
        <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
            <div style={{ width: 10, height: 10, marginRight: 5, backgroundColor: data.color, color: data.color, Radius: 5 }} />
            {short}
        </div>
    ) : (
        <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
            {short}
        </div>
    );
};



const Badge = ({ value, history }) => {
    let backgroundColor;
    if (value <= 2) {
        backgroundColor = 'bg-BADGE_1';
    } else if (value > 2 && value <= 6) {
        backgroundColor = 'bg-BADGE_2';
    } else if (value > 6 && value <= 12) {
        backgroundColor = 'bg-BADGE_3';
    } else {
        backgroundColor = 'bg-BADGE_4';
    }

    let arrow = history !== null ? (history - value > 0 ? ArrowDownGreen : history - value < 0 ? ArrowUpRed : Nill) : null;
    return (
        <div className={`${backgroundColor} text-white h-10 rounded w-full mt-2 text-center flex items-center justify-center inline-block`}>
            <span className="">{value}</span>
            {/*<img src={arrow} alt="Arrow" className="w-4 h-4 ml-1" />*/}
            {arrow && <img src={arrow} alt="Arrow" className="w-4 h-4 ml-1" />}
        </div>
    )
};






const RiskDetailsForm = (props) => {

    const { t } = useTranslation();
    const { confirmDelete, confirm } = useConfirm();
    const { deleted, deleteFailed, genericError: genericErrorFN } = useToast();
    const { framework, complianceStandards, editRiskSaveFN, mode, risk, levels, getRiskFN, getLevelsFN, close, open, openIncident, risk_id, addCommentFN, addControlFN, addActionFN, /*addAttachmentFN,*/ editRiskFN, editControlFN, editActionFN, profile, deleteControlFN, openControl, setControlId, controlopen, openAction, setActionId, actionopen, deleteActionFN, loadingAI, fetchAISuggestions, aiControlDropFN, controls, onRemoveControl, availableAssets } = props;
    ////////console.log("levels", levels);
    ////////console.log(typeof setControlId); // Should log "function"
    ////////console.log("Props in RiskDetailsForm:", props);
    // const fileInputRef = React.useRef(null);

    /*
    const handleFileChange = (event, control) => {
        const file = event.target.files[0];
        if (file) {
            addAttachmentFN(risk_id, control.ControlID, file);
        }
    };

    const handleAttachmentClick = (control) => {

        if (control.ControlAttachment) {
            window.open(control.ControlAttachment, '_blank');
        } else {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        }
    };
*/

    const [isLoading, setIsLoading] = useState(true);
//     useEffect(() => {
//     if (risk_id != null) {
//       getRiskFN(risk_id)
//     }
//   }, [risk_id, getRiskFN])
  
    //////console.log("RISK ID IN RISK OVERLAY", risk_id);

    //const riskResponses = ['Accept', 'Mitigate', 'Transfer', 'Avoid'];

    
    const [newThreatLocal, setNewThreatLocal] = useState("");


    const calculateFinancialLoss = (impact) => {
        const formatNumber = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
        if (!levels || !levels.riskImpacts) {
            console.error("Levels or riskImpacts not available.");
            return formatNumber(0);
        }
    
        // Find the corresponding impact in the levels object
        const impactData = levels.riskImpacts.find((riskImpact) => riskImpact.impact === impact);
    
        if (!impactData) {
            //console.warn(`Impact "${impact}" not found in levels.`);
            return formatNumber(0);
        }
    
        // Handle the special case for "Catastrophe"
        if (impact === "Catastrophe") {
            return formatNumber(impactData.financial_low*4/3);
        }
    
        // Calculate the average financial loss for other impacts
        const { financial_high, financial_low } = impactData;
        const average = (financial_high + financial_low) / 2;
    
        return formatNumber(Math.round(average)); // Format and round the number
    };

    const [formState, setFormState] = useState({
        Title: '',
        Definition: '',
        DefinitionDate: moment().format('YYYY-MM-DD'),
        RiskType: 'Department',
        DepartmentId: props.department_id,
        ComplianceId: null,
        RiskLevel: 'Low',
        RiskCategory: 'Operational',
        RiskStatus: 'Active',
        RiskOwner: '',
        RiskDescription: '',
        RiskThreats: [],
        RiskImpact: '',
        RiskLikelihood: '',
        vulnerability: '',
        threat: '',
        RiskControls: [],
        RiskActions: [],
        Option_C: 'No',
        Option_I: 'No',
        Option_A: 'No',
        compliance_id: 0,
        opportunity: '',
    });


    const [formActionState, setFormActionState] = useState([]);
    const [formControlState, setFormControlState] = useState([]);

    useEffect(() => {
        const companyId = risk?.risk?.CompanyID;
        if (companyId) {
            getLevelsFN(companyId);
        }
    }, [getLevelsFN, risk?.risk?.CompanyID]);

    const getColorForScale = (scale) => {
        const colors = {
            "Rare": "#0081A7",
            "Unlikely": "#00AFB9",
            "Possible": "#FED9B7",
            "Likely": "#F07167",
            "Almost certain": "#b4170b",
        };
        return colors[scale] || "#000000"; // Default to black if scale not found
    };

    const getColorForScaleImpact = (scale) => {
        const colors = {
            "Insignificant": "#0081A7",
            "Minor": "#00AFB9",
            "Moderate": "#FED9B7",
            "Major": "#F07167",
            "Catastrophe": "#b4170b",
        };
        return colors[scale] || "#000000"; // Default to black if scale not found
    };

    const listUsers = risk && risk.users ? risk.users.map(user => ({ value: user.UserID, label: user.FirstName + ' ' + user.LastName })) : [];
    const listDepartments = risk && risk.departments && profile && (profile.role === "Admin" || profile.role === "Auditor") ? risk.departments.map(department => ({ value: department.DepartmentID, label: department.DepartmentName })) : risk && risk.departments && profile && (profile.role === "User") ? risk.departments.filter(department => department.DepartmentID === profile.department_id).map(department => ({ value: department.DepartmentID, label: department.DepartmentName })) : [];
    const listStatus = useMemo(
        () => [
            { value: 'In Review', label: t('riskOverview.statusOptions.inReview') },
            { value: 'Approved', label: t('riskOverview.statusOptions.approved') },
        ],
        [t]
    );

    const listProbability = useMemo(
        () =>
            sortProbabilityScales(levels?.riskProbabilities || []).map((prob) => ({
                value: prob.scale,
                label: translateRiskProbability(prob.scale, t),
                color: getColorForScale(prob.scale),
                frequency: prob.frequency,
            })),
        [levels?.riskProbabilities, t]
    );

    const listImpact = useMemo(
        () =>
            (levels?.riskImpacts || []).map((impact) => ({
                value: impact.impact,
                label: translateRiskImpact(impact.impact, t),
                color: getColorForScaleImpact(impact.impact),
                impact,
            })),
        [levels?.riskImpacts, t]
    );

    const listResponses = useMemo(
        () => [
            { value: 'Accept', label: t('riskOverview.riskResponseOptions.accept'), color: "#0081A7" },
            { value: 'Mitigate', label: t('riskOverview.riskResponseOptions.mitigate'), color: "#00AFB9" },
            { value: 'Transfer', label: t('riskOverview.riskResponseOptions.transfer'), color: "#FED9B7" },
            { value: 'Avoid', label: t('riskOverview.riskResponseOptions.avoid'), color: "#F07167" },
        ],
        [t]
    );
    const listPriority = [{ value: 'Low', label: 'Low', color: "#0081A7" }, { value: 'Medium', label: 'Medium', color: "#00AFB9" }, { value: 'High', label: 'High', color: "#FED9B7" }, { value: 'Urgent', label: 'Urgent', color: "#F07167" }];
    const listProgress = [{ value: 'Not started', label: 'Not started', color: "#0081A7" }, { value: 'In progress', label: 'In progress', color: "#00AFB9" }, { value: 'Completed', label: 'Completed', color: "#FED9B7" }];
    const listControlTypes = [{ value: 'Detective', label: t('controlManagement.filters.detective'), color: "#000000" }, { value: 'Preventive', label: t('controlManagement.filters.preventive'), color: "#000000" }, { value: 'Corrective', label: t('controlManagement.filters.corrective'), color: "#000000" }];

    const [menuOpenId, setMenuOpenId] = React.useState(null);

    const toggleMenu = (id) => {
        setMenuOpenId((prev) => (prev === id ? null : id));
    };


    React.useEffect(() => {
        const onDown = (e) => { if (menuOpenId) setMenuOpenId(null); };
        const onEsc = (e) => { if (e.key === 'Escape') setMenuOpenId(null); };
        window.addEventListener('mousedown', onDown);
        window.addEventListener('keydown', onEsc);
        return () => {
            window.removeEventListener('mousedown', onDown);
            window.removeEventListener('keydown', onEsc);
        };
    }, [menuOpenId]);


    useEffect(() => {
        if (props.isOpen) {
            if (props.isNewRisk) {
                ////console.log('New risk creation mode');
                setIsLoading(false);
                setFormState({
                    Title: '',
                    Definition: '',
                    DefinitionDate: moment().format('YYYY-MM-DD'),
                    RiskType: 'Department',
                    DepartmentId: props.department_id,
                    ComplianceId: null,
                    RiskLevel: 'Low',
                    RiskCategory: 'Operational',
                    RiskStatus: 'Active',
                    RiskThreats: [],
                    RiskOwner: '',
                    RiskDescription: '',
                    RiskImpact: '',
                    RiskLikelihood: '',
                    RiskControls: [],
                    RiskActions: [],
                    vulnerability: '',
                    threat: '',
                    Option_C: 'No',
                    Option_I: 'No',
                    Option_A: 'No',
                    compliance_id: 0,
                    opportunity: '',
                });
            } else if (risk?.risk_id) {
                //////console.log('Fetching risk data for ID:', risk.risk_id);
                setIsLoading(true);
                ////console.log("new created risk!")
                getRiskFN(risk.risk_id);
            }
        } else {
            // Reset state when overlay is closed
            setIsLoading(true);
            setFormState({
                Title: '',
                Definition: '',
                DefinitionDate: moment().format('YYYY-MM-DD'),
                RiskType: 'Department',
                DepartmentId: props.department_id,
                ComplianceId: null,
                RiskLevel: 'Low',
                RiskCategory: 'Operational',
                RiskStatus: 'Active',
                RiskOwner: '',
                RiskThreats: [],
                RiskDescription: '',
                RiskImpact: '',
                RiskLikelihood: '',
                RiskControls: [],
                RiskActions: [],
                vulnerability: '',
                threat: '',
                Option_C: 'No',
                Option_I: 'No',
                Option_A: 'No',
                compliance_id: 0,
                opportunity: ''
            });
        }
    }, [props.isOpen, risk?.risk_id, props.isNewRisk, getRiskFN, props.department_id]);

    // useEffect(() => {

    //     if (!risk_id) return; 

    //     if (risk?.risk.ID === risk_id) {
    //         ////console.log('Received risk data:', risk.risk);
    //         setIsLoading(true)
    //         setFormState({
    //             Title: risk.risk.Title || '',
    //             Definition: risk.risk.Definition || '',
    //             DefinitionDate: risk.risk.DefinitionDate ? moment(risk.risk.DefinitionDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
    //             RiskType: risk.risk.RiskType || 'Department',
    //             DepartmentId: risk.risk.DepartmentId || props.department_id,
    //             ComplianceId: risk.risk.ComplianceId || null,
    //             RiskLevel: risk.risk.RiskLevel || 'Low',
    //             RiskCategory: risk.risk.RiskCategory || 'Operational',
    //             RiskStatus: risk.risk.RiskStatus || 'Active',
    //             RiskOwner: risk.risk.RiskOwner || '',
    //             RiskDescription: risk.risk.RiskDescription || '',
    //             RiskImpact: risk.risk.RiskImpact || '',
    //             RiskLikelihood: risk.risk.RiskLikelihood || '',
    //             RiskControls: risk.risk.RiskControls || [],
    //             RiskActions: risk.risk.RiskActions || [],
    //             vulnerability: risk.risk.vulnerability || '',
    //             threat: risk.risk.threat || '',
    //             Option_C: risk.risk.Option_C ||'No',
    //             Option_I: risk.risk.Option_I ||'No',
    //             Option_A: risk.risk.Option_A ||'No',
    //         });
    //         setIsLoading(false);
    //     }
    // }, [risk?.risk, risk_id]);


    // useEffect(() => {
    //     if (!risk_id) {
    //         ////console.log('Reseting');
    //         setFormState({
    //             Title: '',
    //             Definition: '',
    //             DefinitionDate: moment().format('YYYY-MM-DD'),
    //             RiskType: 'Department',
    //             DepartmentId: props.department_id,
    //             ComplianceId: null,
    //             RiskLevel: 'Low',
    //             RiskCategory: 'Operational',
    //             RiskStatus: 'Active',
    //             RiskOwner: '',
    //             RiskDescription: '',
    //             RiskImpact: '',
    //             RiskLikelihood: '',
    //             vulnerability: '',
    //             threat: '',
    //             RiskControls: [],
    //             RiskActions: [],
    //             Option_C: 'No',
    //             Option_I: 'No',
    //             Option_A: 'No',
    //         });
    //         setIsLoading(false);
    //     }
    // }, [risk_id]);

    useEffect(() => {
        if (!actionopen && risk_id) {
            ////console.log("action!")
            getRiskFN(risk_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionopen]);

    useEffect(() => {
        ////console.log("controlopen ", controlopen)
        if (!controlopen && risk_id) {
            ////console.log("control!")
            getRiskFN(risk_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controlopen]);

    useEffect(() => {
        if (risk && risk.risk) {
            //console.log('Risk data received:', risk);
            setFormState({
                ...formState,
                Title: risk.risk.Title || '',
                Definition: risk.risk.Definition || '',
                Owner: risk.risk.Owner || '',
                DepartmentID: risk.risk.DepartmentID || '',
                Status: risk.risk.Status || '',
                DefinitionDate: risk.risk.DefinitionDate ? moment(risk.risk.DefinitionDate).format('YYYY-MM-DD') : '',
                probability_inherent: risk.risk.probability_inherent || '',
                financial_inherent: risk.risk.financial_inherent || '',
                operational_inherent: risk.risk.operational_inherent || '',
                reputational_inherent: risk.risk.reputational_inherent || '',
                financial_inherent_score: risk.risk.financial_inherent_score || '',
                operational_inherent_score: risk.risk.operational_inherent_score || '',
                reputational_inherent_score: risk.risk.reputational_inherent_score || '',
                financial_residual_score: risk.risk.financial_residual_score || '',
                operational_residual_score: risk.risk.operational_residual_score || '',
                reputational_residual_score: risk.risk.reputational_residual_score || '',
                financial_future_score: risk.risk.financial_future_score || '',
                operational_future_score: risk.risk.operational_future_score || '',
                reputational_future_score: risk.risk.reputational_future_score || '',
                financial_inherent_score_history: risk.risk.financial_inherent_score_history || '',
                operational_inherent_score_history: risk.risk.operational_inherent_score_history || '',
                reputational_inherent_score_history: risk.risk.reputational_inherent_score_history || '',
                financial_residual_score_history: risk.risk.financial_residual_score_history || '',
                operational_residual_score_history: risk.risk.operational_residual_score_history || '',
                reputational_residual_score_history: risk.risk.reputational_residual_score_history || '',
                financial_future_score_history: risk.risk.financial_future_score_history || '',
                operational_future_score_history: risk.risk.operational_future_score_history || '',
                reputational_future_score_history: risk.risk.reputational_future_score_history || '',
                probability_residual: risk.risk.probability_residual || '',
                financial_residual: risk.risk.financial_residual || '',
                operational_residual: risk.risk.operational_residual || '',
                reputational_residual: risk.risk.reputational_residual || '',
                probability_future: risk.risk.probability_future || '',
                financial_future: risk.risk.financial_future || '',
                operational_future: risk.risk.operational_future || '',
                reputational_future: risk.risk.reputational_future || '',
                risk_response: risk.risk.RiskResponse || '',
                ComplianceRisk: risk.risk.ComplianceRisk || '',
                StrategicImpact: risk.risk.StrategicImpact || '',
                vulnerability: risk.risk.vulnerability || '',
                threat: risk.risk.threat || '',
                RiskThreats: risk.threats || [],
                RiskAssets: risk.assets || [],
                Option_C: risk.risk.Option_C ||'No',
                Option_I: risk.risk.Option_I ||'No',
                Option_A: risk.risk.Option_A ||'No',
                compliance_id: risk.risk.compliance_id || 0,
                opportunity: risk.risk.opportunity || '',
            });

            //alert(risk.risk.ComplianceRisk);

            setFormActionState([]);

            

            risk.actions.map(action => {



                let newaction_Progress = listProgress.find(progress => progress.value === action.ActionProgress);
                let newaction_Priority = listPriority.find(priority => priority.value === action.ActionPriority);
                let newaction_StartDate = moment(action.ActionStartDate).format('YYYY-MM-DD');
                let newaction_EndDate = moment(action.ActionEndDate).format('YYYY-MM-DD');
                let newaction2 = {
                    ...action,
                    ActionProgress: newaction_Progress,
                    ActionPriority: newaction_Priority,
                    ActionStartDate: newaction_StartDate,
                    ActionEndDate: newaction_EndDate
                };

                return setFormActionState(prevState => [...prevState, newaction2]);

            });

            setFormControlState([]);


            risk.controls.map(control => {

                // ////////console.log(control);

                let newcontrol_Type = listControlTypes.find(controlType => controlType.value === control.ControlType);

                //////////console.log(newcontrol_Type);

                let newcontrol = {
                    ...control,
                    ControlType: newcontrol_Type
                };

                return setFormControlState(prevState => [...prevState, newcontrol]);
            });

        }
        ////////console.log(risk);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [risk]);




    useEffect(() => {
        if (risk) {
            setIsLoading(false);
        }
    }, [risk]);


    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateServerData = useCallback(
        debounce((data, type, control_id, action_id) => {
            // Make your API call here
            //alert(action_id);
            //////console.log("EDIT DATA RISK ID:", risk_id);

            setIsLoading(true);
            if (type === "risk") {
                editRiskFN(risk_id, data);
            } else if (type === "control") {
                editControlFN(risk_id, control_id, data);
            } else {
                //alert(action_id);
                editActionFN(risk_id, action_id, data);
            }
            //alert("Sending data to server!!");
            // axios.post("/update-data", data); 
        }, 1500), // Adjust the debounce delay (1000 ms = 1 second)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const handleRiskChange = (data) => {

        setFormState(data);
        //updateServerData(data, "risk");

    };

    const handleAddAction = async (risk_id) =>{
        ////console.log("Addding Action ", formState)
        await editRiskSaveFN(risk_id, formState)
        addActionFN(risk_id || null)

    }
    const handleDeleteAction = async (risk_id, action_id) =>{
        const ok = await confirmDelete({
            title: t("common.confirm.deleteActionTitle"),
            message: t("common.confirm.deleteActionMessage"),
        });
        if (!ok) return;
        try {
            await editRiskSaveFN(risk_id, formState)
            deleteActionFN(risk_id, action_id);
            deleted("action");
        } catch {
            deleteFailed("action");
        }

    }
    const handleAddControl = async (risk_id) => {
        try {
            await editRiskSaveFN(risk_id, formState);
            const newControl = await addControlFN(risk_id, formState.Owner);
            await getRiskFN(risk_id);
            if (newControl?.ControlID) {
                setControlId(newControl.ControlID);
            }
        } catch (err) {
            console.error("handleAddControl error:", err);
            genericErrorFN?.();
        }
    }
    const handleDeleteControl = async (risk_id, control_id) =>{
        const ok = await confirmDelete({
            title: t("common.confirm.deleteControlTitle"),
            message: t("common.confirm.deleteControlMessage"),
        });
        if (!ok) return;
        try {
            await editRiskSaveFN(risk_id, formState)
            deleteControlFN(risk_id, control_id)
            deleted("control");
        } catch {
            deleteFailed("control");
        }

    }
     const handleAddComment = async (risk_id, comment) =>{
        await editRiskSaveFN(risk_id, formState)
        addCommentFN(comment, risk_id);

    }


    const probability_inherent_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = selectedImpact; // whatever key you use

        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[formState.financial_inherent] || 0;

        const newScore = probabilityWeight * impactWeight;

        const impactWeightO = impactWeightMap[formState.operational_inherent] || 0;

        const newScoreO = probabilityWeight * impactWeightO;

        const impactWeightR = impactWeightMap[formState.reputational_inherent] || 0;

        const newScoreR = probabilityWeight * impactWeightR;

        // build updated form state
        const updatedData = {
            ...formState,
            probability_inherent: selectedImpact,
            financial_inherent_score: newScore,
            operational_inherent_score: newScoreO,
            reputational_inherent_score: newScoreR
        };

        handleRiskChange(updatedData);

    };

    const financial_inherent_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = formState.probability_inherent; // whatever key you use
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;

        // build updated form state
        const updatedData = {
            ...formState,
            financial_inherent: selectedImpact,
            financial_inherent_score: newScore,
        };

        handleRiskChange(updatedData);

    };


    const operational_inherent_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };
 
        const probability = formState.probability_inherent; // or maybe formState.probability_operational?
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;

        const updatedData = {
            ...formState,
            operational_inherent: selectedImpact,
            operational_inherent_score: newScore
        };

        handleRiskChange(updatedData);
    };

    const reputational_inherent_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

    
        const probability = formState.probability_inherent; // or formState.probability_reputational
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;

        const updatedData = {
            ...formState,
            reputational_inherent: selectedImpact,
            reputational_inherent_score: newScore
        };

        handleRiskChange(updatedData);

    };


    const probability_residual_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = selectedImpact; // whatever key you use

        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[formState.financial_residual] || 0;

        const newScore = probabilityWeight * impactWeight;

        const impactWeightO = impactWeightMap[formState.operational_residual] || 0;

        const newScoreO = probabilityWeight * impactWeightO;

        const impactWeightR = impactWeightMap[formState.reputational_residual] || 0;

        const newScoreR = probabilityWeight * impactWeightR;

        // build updated form state
        const updatedData = {
            ...formState,
            probability_residual: selectedImpact,
            financial_residual_score: newScore,
            operational_residual_score: newScoreO,
            reputational_residual_score: newScoreR
        };

        handleRiskChange(updatedData);

    };

    const financial_residual_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };


        const probability = formState.probability_residual; // or formState.probability_financial_residual if you have one
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;

        const updatedData = {
            ...formState,
            financial_residual: selectedImpact,
            financial_residual_score: newScore
        };

        handleRiskChange(updatedData);

    };

    const operational_residual_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = formState.probability_residual; 
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;

        const updatedData = {
            ...formState,
            operational_residual: selectedImpact,
            operational_residual_score: newScore
        };

        handleRiskChange(updatedData);
    };

    const reputational_residual_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = formState.probability_residual; // or formState.probability_reputational_residual
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;

        const updatedData = {
            ...formState,
            reputational_residual: selectedImpact,
            reputational_residual_score: newScore
        };
        ////console.log("Residul Test", updatedData)
        handleRiskChange(updatedData);
        setHoveredData(null);
    };



    const probability_future_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = selectedImpact; // whatever key you use

        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[formState.financial_future] || 0;

        const newScore = probabilityWeight * impactWeight;

        const impactWeightO = impactWeightMap[formState.operational_future] || 0;

        const newScoreO = probabilityWeight * impactWeightO;

        const impactWeightR = impactWeightMap[formState.reputational_future] || 0;

        const newScoreR = probabilityWeight * impactWeightR;

        // build updated form state
        const updatedData = {
            ...formState,
            probability_future: selectedImpact,
            financial_future_score: newScore,
            operational_future_score: newScoreO,
            reputational_future_score: newScoreR
        };

        handleRiskChange(updatedData);

    };

    const financial_future_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = formState.probability_future; // or formState.probability_financial_future if you have separate ones!
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;

        const updatedData = {
            ...formState,
            financial_future: selectedImpact,
            financial_future_score: newScore
        };

        handleRiskChange(updatedData);
        setHoveredData(null);
    };

    const operational_future_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = formState.probability_future; // or formState.probability_operational_future
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;
        
        const updatedData = {
            ...formState,
            operational_future: selectedImpact,
            operational_future_score: newScore
        };
        ////console.log("Future Test", updatedData)
        handleRiskChange(updatedData);
        setHoveredData(null);
    };

    const reputational_future_change = (selectedImpact) => {
        const probabilityWeightMap = {
            'Rare': 1,
            'Unlikely': 2,
            'Possible': 3,
            'Likely': 4,
            'Almost certain': 5
        };

        const impactWeightMap = {
            'Insignificant': 1,
            'Minor': 2,
            'Moderate': 3,
            'Major': 4,
            'Catastrophe': 5
        };

        const probability = formState.probability_future; // or formState.probability_reputational_future
        const probabilityWeight = probabilityWeightMap[probability] || 0;
        const impactWeight = impactWeightMap[selectedImpact] || 0;

        const newScore = probabilityWeight * impactWeight;

        const updatedData = {
            ...formState,
            reputational_future: selectedImpact,
            reputational_future_score: newScore
        };

        handleRiskChange(updatedData);
        setHoveredData(null);
    };


    const handleControlChange = (data, control_id) => {

        // ////////console.log(data);
        setFormControlState(data);

        //update the control details by control_id instead of index 
        let updatedControl = data.find(control => control.ControlID === control_id);
        updateServerData(updatedControl, "control", control_id);
    };


    const handleActionChange = (data, action_id) => {

        setFormActionState(data);
        let updatedAction = data.find(action => action.ActionID === action_id);
        updateServerData(updatedAction, "action", null, action_id);
    };




    const disableEvent = React.useCallback(
        (e) => {
            //alert("disableEvent");
            e.persist();

            if (profile.role === "Auditor") {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const handleAISuggestions = async () => {
        ////////console.log(formState.Title, formState.Definition);
    
        if (!(formState.Title || "").trim()) {
            alert("Please fill in the title!", {
                position: "top-center",
                autoClose: 3000, // Closes after 3 seconds
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { backgroundColor: "#f8f8f8", color: "#000" }, // Custom styling
            });
            return; // Exit function
        }
    
        if (!(formState.Definition || "").trim()) {
            alert("Please fill in the definition!", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { backgroundColor: "#f8f8f8", color: "#000" },
            });
            return;
        }
        await editRiskFN(risk_id, formState)
        setControlsTab('askRabo');
        // Call the API with the current Title and Definition
        fetchAISuggestions(formState.Title, formState.Definition, formState.RiskThreats);
    };

    const [hoveredData, setHoveredData] = useState(null); // { value: string, position: { top: number, left: number } }
    const [controlsTab, setControlsTab] = useState('controls');

    const [{ isOver }, dropRef] = useDrop(() => ({
        accept: 'CONTROL',
        drop: (item) => {
            ////////console.log("Dropped item index:", item.index);
            ////////console.log(controls);
            // Access the correct control from the latest state
            const droppedControl = item.control; 
            ////////console.log("Dropped control:", droppedControl);
    
            // Handle the drop with the correct control
            handleDrop(droppedControl);
        },
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));
    



    const handleDrop = async (droppedControl) => {
        ////console.log("Control received in handleDrop:", droppedControl);
        ////console.log("Riks state", formState)
        // Prepare the control data
        const controlData = {
            ControlID: droppedControl.ControlID,
            ControlNumber: droppedControl.ControlNumber || 1000,  // Default or new control number
            ControlDetails: droppedControl.title,  // Control details from the dropped control
            ControlDefinition: droppedControl.description,
            ControlType: droppedControl.type,     // Control type from the dropped control
            ControlAttachment: droppedControl.attachment || null, // Control attachment if exists
            ComplianceTypes: droppedControl.complianceTypes || [],
            ChecklistItems: droppedControl.checklist || [],
        };
    
        // **Optimistic UI update**: Immediately update the frontend with the dropped control
        setFormControlState(prevState => [
            ...prevState,
            controlData  // Add the dropped control to the state immediately
        ]);
        // Call the API
        aiControlDropFN(risk_id, controlData)
            .then((data) => {
                ////////console.log("AI control drop success:", data);
            })
            .catch((err) => {
                console.error("Error while adding or updating control:", err);
                // Optionally, revert control state if the API call fails
                setFormControlState(prevState => prevState.filter(control => control.ControlID !== droppedControl.ControlID));
            });
    };


    const handleCloseClick = async () => {
        if (formState.Title === "Untitled Risk") {
            const confirmed = await confirm({
                title: t("common.confirm.untitledRiskCloseTitle"),
                message: t("common.confirm.untitledRiskCloseMessage"),
            });

            if (!confirmed) {
                return; 
            }
        }

        close(formState, risk_id);
    };

    const useModalShell = typeof open === "boolean";

    const handleModalClose = () => {
        handleCloseClick();
    };

    const inner = (
        <Disable disabled={isLoading} onClick={disableEvent} onKeyDown={disableEvent}>
            <div className={useModalShell ? "px-6 pb-6" : "p-8"} style={profile.role === "Auditor" ? { pointerEvents: 'none', userSelect: 'none' } : { pointerEvents: 'auto', userSelect: 'auto' }}>
                <div className={useModalShell ? "" : "p-6 bg-white rounded-lg"}>
                    {!useModalShell && (
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-1xl font-semibold text-[#3b3b3b]">{t("riskOverview.riskDetails")}</h1>
                        <div className="absolute top-2 right-2">
                            <img
                                src={CloseIcon}
                                alt={t("riskOverview.close")}
                                className="w-6 h-6 cursor-pointer"
                                onClick={() => handleCloseClick()} 
                            />
                        </div>
                    </div>
                    )}


                    <div className="mb-6">
                    <input
                        type="text"
                        placeholder={t("riskOverview.untitledRiskPlaceholder")}
                        value={formState.Title}
                        onChange={(e) => handleRiskChange({ ...formState, Title: e.target.value })}
                        className="w-full p-3 rounded mb-4 bg-[#EEF0ED] text-black text-sm"
                        style={{
                            border: 'none', // Remove actual borders
                            backgroundColor: '#EEF0ED',
                            padding: '8px',
                            outline: 'none',
                            transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                            boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                        }}
                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                        />

                        <textarea
                        placeholder={t("riskOverview.definitionPlaceholder")}
                        value={formState.Definition}
                        onChange={(e) => handleRiskChange({ ...formState, Definition: e.target.value })}
                        className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                        style={{
                            border: 'none', // Remove actual borders
                            backgroundColor: '#EEF0ED',
                            padding: '8px',
                            outline: 'none',
                            transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                            boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                        }}
                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                        />



                    </div>

                    {/* Opportunity / Correlation (only for framework 1) */}
                    {framework === 1 && (
                        <div className="mb-6">
                            <label className="block text-sm font-medium text-[#3b3b3b] mb-2">
                                {t("riskOverview.opportunity")}
                            </label>
                            <textarea
                                className="w-full p-3 text-sm text-black bg-[#EEF0ED] rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-gray-300"
                                rows={4}
                                placeholder={t("riskOverview.opportunityPlaceholder")}
                                value={formState.opportunity || ""}
                                style={{
                                    border: 'none', // Remove actual borders
                                    backgroundColor: '#EEF0ED',
                                    padding: '8px',
                                    outline: 'none',
                                    transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                    boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                                }}
                                onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                                onChange={(e) =>
                                    handleRiskChange({
                                        ...formState,
                                        opportunity: e.target.value,
                                    })
                                }
                            />
                        </div>
                    )}


                        {/* {formState.DepartmentID === 1 && (
                            <>
                        <div className="mb-6">
                   
                        <label className="text-[#3b3b3b] mb-2 text-sm">Vulnerability</label>
                        <textarea
                            placeholder="Vulnerability Definition"
                            value={formState.vulnerability}
                            onChange={(e) => handleRiskChange({ ...formState, vulnerability: e.target.value })}
                            className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                            style={{
                                border: 'none', // Remove actual borders
                                backgroundColor: '#EEF0ED',
                                padding: '8px',
                                outline: 'none',
                                transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                            }}
                            onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                            onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                        />
                    </div>

                    <div className="mb-6">
                   
                        <label className="text-[#3b3b3b] mb-2 text-sm">Threat</label>
                        <textarea
                            placeholder="Threat Definition"
                            value={formState.threat}
                            onChange={(e) => handleRiskChange({ ...formState, threat: e.target.value })}
                            className="w-full h-24 p-3 rounded bg-[#EEF0ED] text-black text-sm"
                            style={{
                                border: 'none', // Remove actual borders
                                backgroundColor: '#EEF0ED',
                                padding: '8px',
                                outline: 'none',
                                transition: 'box-shadow 0.1s', // Smooth transition for box-shadow
                                boxShadow: 'inset 0 0 0 0 #3b3b3b', // Start with no shadow
                            }}
                                    onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')} // Add box-shadow on focus
                                    onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')} // Remove box-shadow on blur
                                />
                            </div>

                            <div className="mb-6">
                                <label className="text-[#3b3b3b] mb-2 text-sm block">
                                    CIA Options
                                </label>
                                <div className="flex flex-col gap-4">
                                    {["C", "I", "A"].map((label) => {
                                        const fieldName = `Option_${label}`;
                                        return (
                                            <div key={label} className="flex items-center justify-between">
                                                <span className="text-sm text-[#3b3b3b]">{label}</span>
                                                <div className="flex gap-4">
                                                    <label className="flex items-center gap-1 text-sm text-[#3b3b3b]">
                                                        <input
                                                            type="radio"
                                                            name={fieldName}
                                                            value="Yes"
                                                            checked={formState[fieldName] === "Yes"}
                                                            onChange={() =>
                                                                handleRiskChange({
                                                                    ...formState,
                                                                    [fieldName]: "Yes",
                                                                })
                                                            }
                                                        />
                                                        Yes
                                                    </label>
                                                    <label className="flex items-center gap-1 text-sm text-[#3b3b3b]">
                                                        <input
                                                            type="radio"
                                                            name={fieldName}
                                                            value="No"
                                                            checked={formState[fieldName] === "No"}
                                                            onChange={() =>
                                                                handleRiskChange({
                                                                    ...formState,
                                                                    [fieldName]: "No",
                                                                })
                                                            }
                                                        />
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                    </>
                        )} */}


                    {/* Threats */}
                    {risk && risk.threats && risk.threats?.length >= 0 &&
                    <div className="flex flex-col mb-4">
                        {/* Title + count */}
                        <div className="flex items-center justify-between mb-2">
                            <label className="text-[#3b3b3b] mb-0 text-sm font-bold">
                                {t("riskOverview.threatsCount", { count: formState.RiskThreats?.length || 0 })}
                            </label>
                        </div>

                        {/* Threat Items */}
                        <ul className="bg-transparent rounded-md p-0 w-full">
                            {formState.RiskThreats?.map((item, index) => (
                                <li
                                    key={item.threat_id || index}
                                    className="flex items-center justify-between mb-0 p-1 rounded hover:bg-[#EEF0ED]"
                                >
                                    <div className="flex items-center w-full">
                                        <input
                                            type="text"
                                            value={item.text}
                                            onChange={(e) => {
                                                const updated = (formState.RiskThreats || []).map((t, idx) =>
                                                    idx === index ? { ...t, text: e.target.value } : t
                                                );
                                                handleRiskChange({ ...formState, RiskThreats: updated });
                                            }}
                                            className="p-1 text-sm bg-transparent focus:border-none focus:outline-none w-full text-black"
                                            placeholder={t("riskOverview.enterThreat")}
                                        />
                                    </div>
                                    <button
                                        className="text-black ml-2 hover:text-red-600"
                                        onClick={() => {
                                            const updated = (formState.RiskThreats || []).filter((_, idx) => idx !== index);
                                            handleRiskChange({ ...formState, RiskThreats: updated });
                                        }}
                                    >
                                        <TfiTrash size={16} />
                                    </button>
                                </li>
                            ))}
                        </ul>

                        {/* Add New Threat */}
                        <div className="flex items-center p-1 rounded hover:bg-[#EEF0ED] mt-2">
                            <input
                                type="text"
                                className="p-1 text-sm text-black bg-transparent focus:border-none focus:outline-none w-full"
                                placeholder={t("riskOverview.addThreat")}
                                value={newThreatLocal || ""}
                                onChange={(e) => {
                                    setNewThreatLocal(e.target.value);
                                    handleRiskChange({ ...formState, newThreat: e.target.value });
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && newThreatLocal?.trim()) {
                                        e.preventDefault();
                                        const newThreats = [...(formState.RiskThreats || []), { text: newThreatLocal.trim() }];
                                        setNewThreatLocal("");
                                        handleRiskChange({ ...formState, RiskThreats: newThreats, newThreat: "" });
                                    }
                                }}
                                onBlur={() => {
                                    if (newThreatLocal?.trim()) {
                                        const newThreats = [...(formState.RiskThreats || []), { text: newThreatLocal.trim() }];
                                        setNewThreatLocal("");
                                        handleRiskChange({ ...formState, RiskThreats: newThreats, newThreat: "" });
                                    }
                                }}
                            />
                        </div>
                    </div>}


                    {/* Risk Owner, Department, Status, Compliance Standard */}
                    <div className={`grid ${mode !== "compliance" ? "grid-cols-4" : "grid-cols-3"} gap-4 mb-6`}>
                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.riskOwner")}</label>
                            <Select
                                options={listUsers}
                                placeholder={t("riskOverview.riskOwner")}
                                className="text-sm text-black"
                                onChange={(e) => handleRiskChange({ ...formState, Owner: e.value })}
                                styles={customStyles}
                                value={listUsers.find(user => user.value === formState.Owner)}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.department")}</label>
                            <Select
                                options={listDepartments}
                                className="text-black text-sm"
                                placeholder={t("riskOverview.department")}
                                onChange={(e) => handleRiskChange({ ...formState, DepartmentID: e.value })}
                                styles={customStyles}
                                value={listDepartments.find(department => department.value === formState.DepartmentID)}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.status")}</label>
                            <Select
                                options={listStatus}
                                placeholder={t("riskOverview.status")}
                                className="text-sm"
                                onChange={(e) => handleRiskChange({ ...formState, Status: e.value })}
                                styles={customStyles}
                                value={listStatus.find(status => status.value === formState.Status)}
                            />
                        </div>

                        {mode !== "compliance" && (
                            <div className="flex flex-col">
                                <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.complianceStandard")}</label>

                                <Select
                                    options={(complianceStandards || []).map(cs => ({
                                        value: String(cs.compliance_id),
                                        label: cs.name,
                                    }))}
                                    placeholder={t("riskOverview.complianceStandard")}
                                    className="text-sm"
                                    styles={customStyles}
                                    onChange={(e) =>
                                        handleRiskChange({
                                            ...formState,
                                            compliance_id: e ? Number(e.value) : null, // store as number in state/db
                                        })
                                    }
                                    value={
                                        (() => {
                                            const id = formState?.compliance_id;
                                            if (id == null) return null;

                                            const match = (complianceStandards || []).find(
                                                cs => String(cs.compliance_id) === String(id)
                                            );

                                            return match
                                                ? { value: String(match.compliance_id), label: match.name }
                                                : null;
                                        })()
                                    }
                                />
                            </div>
                        )}

                    </div>


                    {/* Inherent Risk Assessment */}
                    <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.inherentAssessment")}</h3>
                    <div className="grid grid-cols-4 gap-4 mb-4">
                        {/*<input
                    type="text"
                    placeholder="Probability"
                    className="p-3   rounded bg-[#EEF0ED] text-black h-10"
                    value={formState.probability_inherent}
                    onChange={(e) => setFormState({ ...formState, probability_inherent: e.target.value })}
                />*/}

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.probability")}</label>
                            <Select
                                options={listProbability}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {
                                    probability_inherent_change(e.value);
                                    setHoveredData(null); // Clear hover value on selection
                                }}
                                styles={customStyles}
                                components={{
                                    Option: probabilityOption,
                                    SingleValue: probabilitySingleValue,
                                }}
                                value={
                                    formState.probability_inherent
                                        ? listProbability.find(
                                              (probability) =>
                                                  probability.value?.toLowerCase() === formState.probability_inherent.toLowerCase()
                                          ) || null
                                        : null
                                }
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="probability"
                                setHoveredData={setHoveredData}
                            />
                        </div>
                        
                        {hoveredData && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: hoveredData.position.top,
                                    left: hoveredData.position.left,
                                    zIndex: 9999,
                                    backgroundColor: "white",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                    padding: "8px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {hoveredData.value}
                            </div>
                        )}                        



                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.financialImpact")}</label>
                            <Select
                                options={listImpact}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {financial_inherent_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.financial_inherent)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="financial"
                                setHoveredData={setHoveredData}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.operationalImpact")}</label>
                            <Select
                                placeholder={t("riskOverview.selectPlaceholder")}
                                options={listImpact}
                                onChange={(e) => {operational_inherent_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.operational_inherent)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="operational"
                                setHoveredData={setHoveredData}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{mode==='compliance'? t("riskOverview.complianceImpact") : t("riskOverview.reputationalImpact")}</label>
                            <Select
                                options={listImpact}
                                onChange={(e) => {reputational_inherent_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.reputational_inherent)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                placeholder={t("riskOverview.selectPlaceholder")}
                                context="reputational"
                                setHoveredData={setHoveredData}
                            />
                        </div>
                    </div>

                    {/* Inherent Risk Score */}
                    <div className="grid grid-cols-4 gap-4 mb-8">
                    <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.estimatedLoss")}</span>
                            <div className="bg-[#F07167] text-white h-10 rounded w-full mt-2 text-center flex items-center justify-center">${calculateFinancialLoss(formState.financial_inherent)}</div>
                        </div>
                        <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.pillar.financial")}</span>
                            <Badge value={formState.financial_inherent_score} history={formState.financial_inherent_score_history} />
                        </div>
                        <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.pillar.operational")}</span>
                            <Badge value={formState.operational_inherent_score} history={formState.operational_inherent_score_history} />
                        </div>
                        <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.pillar.reputational")}</span>
                            <Badge value={formState.reputational_inherent_score} history={formState.reputational_inherent_score_history} />
                        </div>
                        
                    </div>

                    <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.riskResponse")}</label>
                    

                    {/* Controls */}
                    <div className="mb-4 flex justify-between items-center">

                        <Select
                            options={listResponses}
                            placeholder={t("riskOverview.riskResponsePlaceholder")}
                            onChange={(e) => handleRiskChange({ ...formState, risk_response: e.value })}
                            styles={customStyles}
                            components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                            value={listResponses.find(response => response.value === formState.risk_response)}
                            className="my-custom-select text-sm"
                            classNamePrefix="my-custom-select"
                            context=""
                            setHoveredData={setHoveredData}
                        />

                        <div className="flex items-center gap-4 mt-2 mb-2">
                        <button
                            onClick={() => handleAISuggestions()}
                            className={`relative bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white rounded px-4 py-2 shadow-lg transition duration-300 ease-in-out hover:shadow-2xl hover:scale-105 focus:outline-none ${
                                loadingAI ? 'animate-pulse' : ''
                            }`}
                            disabled={loadingAI}
                            style={{
                                minWidth: '120px',
                                minHeight: '32px',
                                boxShadow: loadingAI
                                    ? '0 0 20px 5px rgba(139, 92, 246, 0.8)'
                                    : '0 0 5px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            <span className="absolute inset-0 rounded blur-md opacity-50 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"></span>
                            <span className="relative">{t("riskOverview.askRabo")}</span>
                        </button>

                        <button
                            className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70"
                            onClick={() =>handleAddControl(risk_id)}
                        >
                            {t("riskOverview.addNewControl")}
                        </button>
                    </div>
                    </div>

                    {/* Tab bar */}
                    <div className="flex border-b border-gray-200 mb-3">
                        <button
                            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
                                controlsTab === 'controls'
                                    ? 'border-[#3b3b3b] text-[#3b3b3b]'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'
                            }`}
                            onClick={() => setControlsTab('controls')}
                        >
                            {t("riskOverview.controls")}
                        </button>
                        <button
                            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
                                controlsTab === 'askRabo'
                                    ? 'border-purple-500 text-purple-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'
                            }`}
                            onClick={() => setControlsTab('askRabo')}
                        >
                            {t("riskOverview.askRabo")}{controls?.length > 0 ? ` (${controls.length})` : loadingAI ? ' …' : ''}
                        </button>
                    </div>

                    {/* Controls tab content - keep mounted so drop zone ref stays active */}
                    <div className={controlsTab !== 'controls' ? 'hidden' : ''}>
                    {risk && risk.controls && risk.controls?.length >= 0 &&
                        <div
                            ref={dropRef}
                            className={`table w-full mb-6 border border-gray-30 rounded-lg ${isOver ? 'bg-blue-100' : 'bg-[#EEF0ED]'
                                }`}
                        >
                            <div className="table-row bg-[#EEF0ED]">
                                <div className="table-cell p-4 font-semibold">{t("riskOverview.table.number")}</div>
                                <div className="table-cell p-4 font-semibold">{t("riskOverview.table.title")}</div>
                                <div className="table-cell p-4 font-semibold"></div>
                            </div>
                            {risk.controls.map((control, index) => (
                                <div className="table-row bg-white hover:bg-[#f8f8f8] hover:shadow-sm transition cursor-pointer" key={control.ControlID}
                                    onClick={() => {
                                        setControlId(control.ControlID);
                                        openControl();
                                    }}>
                                    <div className="table-cell p-4 border-b border-gray-300">
                                        <span className="font-semibold">
                                            {control.ControlNumber}
                                        </span>
                                    </div>
                                    <div className="table-cell hover:bg-[#f8f8f8] p-4 border-b border-gray-300">
                                        <input
                                            type="text"
                                            value={
                                                formControlState.find(
                                                    (c) => c.ControlID === control.ControlID
                                                )?.ControlDetails || ''
                                            }

                                            className="w-[400px] p-2 cursor-pointer hover:bg-[#f8f8f8] "
                                            onClick={() => {
                                                setControlId(control.ControlID);
                                                openControl();
                                            }}
                                            readOnly
                                        />
                                    </div>
                                    <div className="table-cell p-4 border-b border-gray-300">
                                        {/* 3-dots menu */}
                                        <div className="relative inline-block">
                                            <i
                                                className="fa fa-ellipsis-h cursor-pointer text-[#3b3b3b] hover:text-[#3b3b3b]/50 ml-2"
                                                title="More"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleMenu(control.ControlID);
                                                }}
                                            />
                                            {menuOpenId === control.ControlID && (
                                                <div
                                                    className="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-20"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <button
                                                        className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                                                        onClick={() => {
                                                            setMenuOpenId(null);
                                                            setControlId(control.ControlID);
                                                            openControl();
                                                        }}
                                                    >
                                                        {t("riskOverview.edit")}
                                                    </button>
                                                    <button
                                                        className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50"
                                                        onClick={() => {
                                                            setMenuOpenId(null);
                                                            handleDeleteControl(risk_id, control.ControlID);
                                                        }}
                                                    >
                                                        {t("riskOverview.delete")}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            ))}
                        </div>}
                    </div>

                    {/* Ask Rabo tab content */}
                    <div className={controlsTab !== 'askRabo' ? 'hidden' : 'mb-6'}>
                        {loadingAI && (
                            <div className="flex justify-center items-center py-8 text-sm text-gray-500">
                                {t("riskOverview.generatingSuggestions")}
                            </div>
                        )}
                        {!loadingAI && (!controls || controls.length === 0) && (
                            <div className="flex justify-center items-center py-8 text-sm text-gray-400">
                                {t("riskOverview.askRaboEmpty", { action: t("riskOverview.askRabo") })}
                            </div>
                        )}
                        {!loadingAI && controls?.map((control, index) => (
                            <div key={control.id} className="mb-2">
                                <DraggableControlCard
                                    control={control}
                                    index={index}
                                    onRemove={() => onRemoveControl && onRemoveControl(control.id)}
                                />
                                <button
                                    onClick={() => {
                                        handleDrop(control);
                                        onRemoveControl && onRemoveControl(control.id);
                                    }}
                                    className="w-full mt-1 py-1.5 rounded bg-[#3b3b3b] text-white text-xs font-medium hover:bg-opacity-80 transition"
                                >
                                    {t("riskOverview.addToRisk")}
                                </button>
                            </div>
                        ))}
                    </div>


                    {/* Residual Risk */}
                    <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.residualAssessment")}</h3>
                    <div className="grid grid-cols-4 gap-4 mb-4">


                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.probability")}</label>
                            <Select
                                options={listProbability}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {probability_residual_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listProbability.find(probability => probability.value === formState.probability_residual)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="probability"
                                setHoveredData={setHoveredData}
                            />
                        </div>


                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.financialImpact")}</label>
                            <Select
                                options={listImpact}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {financial_residual_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.financial_residual)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="financial"
                                setHoveredData={setHoveredData}
                            />
                        </div>


                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.operationalImpact")}</label>
                            <Select
                                options={listImpact}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {operational_residual_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.operational_residual)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="operational"
                                setHoveredData={setHoveredData}
                            />
                        </div>


                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{mode==='compliance'? t("riskOverview.complianceImpact") : t("riskOverview.reputationalImpact")} </label>
                            <Select
                                options={listImpact}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {reputational_residual_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.reputational_residual)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="reputational"
                                setHoveredData={setHoveredData}
                            />
                        </div>

                    </div>

                    {/* Residual Risk Score */}
                    <div className="grid grid-cols-4 gap-4 mb-8">
                    <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.estimatedLoss")}</span>
                            <div className="bg-[#F07167] text-white h-10 rounded w-full mt-2 text-center flex items-center justify-center">${calculateFinancialLoss(formState.financial_residual)}</div>
                        </div>
                        <div className="flex flex-col text-sm items-start">
                            <span className="text-left text-[#3b3b3b]">{t("riskOverview.pillar.financial")}</span>
                            <Badge value={formState.financial_residual_score} history={formState.financial_residual_score_history} />
                        </div>
                        <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.pillar.operational")}</span>
                            <Badge value={formState.operational_residual_score} history={formState.operational_residual_score_history} />
                        </div>
                        <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.pillar.reputational")}</span>
                            <Badge value={formState.reputational_residual_score} history={formState.reputational_residual_score_history} />
                        </div>
                        
                    </div>



                    {/* Actions */}
                    {(formState.risk_response === "Mitigate" || formState.risk_response === "Avoid") && <>
                        <div className="mb-4 flex justify-between items-center">
                            <h3 className="font-semibold text-[#3b3b3b]">{t("riskOverview.actionsSection")}</h3>
                            <button className="bg-[#3b3b3b] text-white py-2 px-4 rounded" onClick={() => handleAddAction(risk_id)}>{t("riskOverview.addNewAction")}</button>
                        </div>

                        {risk && risk.actions && risk.actions?.length > 0 && <div className="table w-full mb-6 border border-gray-300 rounded-lg bg-[#EEF0ED] relative z-10">
                            <div className="table-row bg-[#EEF0ED]">
                                <div className="table-cell p-4 -b  font-semibold w-[50px]">{t("riskOverview.table.number")}</div>
                                <div className="table-cell p-4 -b  font-semibold">{t("riskOverview.table.title")}</div>
                                {/*<div className="table-cell p-4 -b  font-semibold">Progress</div>
                                <div className="table-cell p-4 -b  font-semibold">Start</div>
                                <div className="table-cell p-4 -b  font-semibold">End</div>
                                <div className="table-cell p-4 -b  font-semibold">Priority</div>*/}
                                <div className="table-cell p-4 -b  font-semibold"></div>
                            </div>

                            {risk && risk.actions && risk.actions?.length > 0 && risk.actions.map((action, index) => (
                                <div className="table-row bg-white z-0 hover:bg-[#f8f8f8] hover:shadow-sm transition cursor-pointer"
                                    onClick={() => {
                                        setActionId(action.ActionID);
                                        openAction();
                                    }}>
                                    <div className="table-cell p-2 border-b border-gray-300 w-[50px] align-middle">
                                        <span className="font-semibold">{action.ActionNumber}</span>
                                    </div>
                                    <div className="table-cell p-2 border-b border-gray-300 align-middle">
                                        {/* <ContentEditable
                                    html={formActionState[index]?.ActionTitle || ''}
                                    onChange={(e) => handleActionChange(index, 'ActionTitle', e.target.value, action.ActionID)}
                                /> */}
                                        <input
                                            type="text"
                                            //value={formActionState[index]?.ActionTitle || ''}
                                            //onChange={(e) => handleActionChange({ ...formActionState, ActionTitle: e.target.value }, )}
                                            //onChange={(e) => handleActionChange(index, 'ActionTitle', e.target.value, action.ActionID)}
                                            className='w-[400px] p-2  hover:bg-[#f8f8f8] cursor-pointer'
                                            value={formActionState.find(a => a.ActionID === action.ActionID)?.ActionTitle || ''}
                                            onClick={() => {
                                                setActionId(action.ActionID);
                                                openAction();
                                            }}
                                            readOnly
                                            onChange={(e) => {
                                                const action_id = action.ActionID;
                                                const updatedActions = [...formActionState];
                                                //update the control details by control_id instead of index
                                                const actionToUpdate = updatedActions.find(a => a.ActionID === action_id);
                                                if (actionToUpdate) {
                                                    actionToUpdate.ActionTitle = e.target.value;
                                                }

                                                //handleActionChange(updatedActions, action_id);
                                            }}


                                        />
                                    </div>

                                
                                    <div className="table-cell p-4 border-b border-gray-300">
                                        <div className="relative inline-block">
                                            <i
                                                className="fa fa-ellipsis-h cursor-pointer text-[#3b3b3b] hover:text-[#3b3b3b]/50 ml-6"
                                                title="More"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleMenu(`action-${action.ActionID}`);
                                                }}
                                            />
                                            {menuOpenId === `action-${action.ActionID}` && (
                                                <div
                                                    className="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-20"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <button
                                                        className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                                                        onClick={() => {
                                                            setMenuOpenId(null);
                                                            setActionId(action.ActionID);
                                                            openAction(); // Edit
                                                        }}
                                                    >
                                                        {t("riskOverview.edit")}
                                                    </button>
                                                    <button
                                                        className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50"
                                                        onClick={() => {
                                                            setMenuOpenId(null);
                                                            handleDeleteAction(risk_id, action.ActionID); // Delete
                                                        }}
                                                    >
                                                        {t("riskOverview.delete")}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>}
                    </>}

                    {/* Future Risk */}
                    <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.futureAssessment")}</h3>
                    <div className="grid grid-cols-4 gap-4 mb-4">


                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.probability")}</label>
                            <Select
                                options={listProbability}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {probability_future_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listProbability.find(probability => probability.value === formState.probability_future)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="probability"
                                setHoveredData={setHoveredData}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.financialImpact")}</label>
                            <Select
                                options={listImpact}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {financial_future_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.financial_future)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="financial"
                                setHoveredData={setHoveredData}
                            />

                        </div>

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{t("riskOverview.operationalImpact")}</label>
                            <Select
                                options={listImpact}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {operational_future_change(e.value); setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.operational_future)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="operational"
                                setHoveredData={setHoveredData}
                            />

                        </div>

                        <div className="flex flex-col">
                            <label className="text-[#3b3b3b] mb-2 text-sm">{mode==='compliance'? t("riskOverview.complianceImpact") : t("riskOverview.reputationalImpact")}</label>
                            <Select
                                options={listImpact}
                                placeholder={t("riskOverview.selectPlaceholder")}
                                onChange={(e) => {reputational_future_change(e.value);  setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.reputational_future)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="reputational"
                                setHoveredData={setHoveredData}
                            />

                        </div>
                    </div>

                    {/* Future Risk Score */}
                    <div className="grid grid-cols-4 gap-4 mb-8">
                    <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.estimatedLoss")}</span>
                            <div className="bg-[#F07167] text-white h-10 rounded w-full mt-2 text-center flex items-center justify-center">${calculateFinancialLoss(formState.financial_future)}</div>
                        </div>
                        <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.pillar.financial")}</span>
                            <Badge value={formState.financial_future_score} history={formState.financial_future_score_history} />
                        </div>
                        <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.pillar.operational")}</span>
                            <Badge value={formState.operational_future_score} history={formState.operational_future_score_history} />
                        </div>
                        <div className="flex flex-col items-start">
                            <span className="text-left text-sm text-[#3b3b3b]">{t("riskOverview.pillar.reputational")}</span>
                            <Badge value={formState.reputational_future_score} history={formState.reputational_future_score_history} />
                        </div>
                        
                    </div>


                    <h3 className="font-semibold mb-3 text-[#3b3b3b]">{t("riskOverview.strategicImpact")}</h3>
                    <div className="grid grid-cols-4 gap-4 mb-6">



                    <div className="flex flex-col">
                            {/* <label className="text-[#3b3b3b] mb-2 text-sm">Strategic Impact</label> */}
                            <Select
                                placeholder={t("riskOverview.selectPlaceholder")}
                                options={listImpact}
                                onChange={(e) => {handleRiskChange({ ...formState, StrategicImpact: e.value });  setHoveredData(null);}}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listImpact.find(impact => impact.value === formState.StrategicImpact)}
                                className="my-custom-select text-sm"
                                classNamePrefix="my-custom-select"
                                context="strategic"
                                setHoveredData={setHoveredData}
                            />
                        </div>

                        <button className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70" onClick={openIncident}>{t("riskOverview.reportIncident")}</button>

                    </div>

                    <CommentsSection
                        comments={risk?.comments}
                        profile={profile}
                        title={t("riskOverview.comments")}
                        placeholder={t("riskOverview.commentsPlaceholder")}
                        addButtonLabel={t("riskOverview.addComment")}
                        onSubmit={(html) => handleAddComment(risk_id, html)}
                    />


                </div >
            </div>
        </Disable >
    );

    if (useModalShell && !open) {
        return null;
    }

    if (useModalShell) {
        return (
            <Modal
                onClose={handleModalClose}
                overlayZIndex="z-[400]"
                maxWidth="max-w-[900px]"
                className="rounded-xl"
            >
                <ModalHeader onClose={handleModalClose}>
                    <span className="text-lg font-semibold text-gray-900 truncate">
                        {formState.Title?.trim() || t("riskOverview.riskDetails")}
                    </span>
                </ModalHeader>
                <ModalBody className="py-0 px-0 overflow-y-auto max-h-[calc(90vh-8rem)]">
                    {inner}
                </ModalBody>
            </Modal>
        );
    }

    return inner;
};


const mapStateToProps = (state) => {
    return {
        risk: state.risk.risk,
        profile: state.profile.profile,
        levels: state.risk.levels,
        risk_id: state.risk.id,
        availableAssets: state.asset.assets || [],
    };
};

const mapDispatchToProps = (dispatch) => {
    
    return {
        getRiskFN: (id) =>  dispatch(getRisk(id)),
        addCommentFN: (comment, risk_id) => dispatch(addComment(comment, risk_id)),
        addControlFN: (risk_id, owner_id) => {
            return dispatch(addControl(risk_id, owner_id));  // Ensure it returns the Promise
        },
        addActionFN: (risk_id) => dispatch(addAction(risk_id)),
        addAttachmentFN: (risk_id, control_id, file) => dispatch(addAttachment(risk_id, control_id, file)),
        editRiskFN: (risk_id, risk) => dispatch(editRisk(risk_id, risk)),
        editRiskSaveFN: (risk_id, risk) => dispatch(editRiskSave(risk_id, risk)),
        editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        deleteControlFN: (risk_id, action_id) => dispatch(deleteControl(risk_id, action_id)),
        deleteActionFN: (risk_id, action_id) => dispatch(deleteAction(risk_id, action_id)),
        getLevelsFN: (id) => dispatch(getLevels(id)),
        aiControlDropFN: (risk_id, control_data) => dispatch(aiControlDrop(risk_id, control_data)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(RiskDetailsForm);